import { icons } from '@lifebit-ai/lds'
import React from 'react'

import { useToggleState } from 'hooks/useToggleState'

import { ImportRequestStatus as ImportRequestStatusBadge } from 'modules/requests/components/ImportRequestStatus'
import { ImportRequestAssignToModal } from 'modules/requests/ImportRequestAssignToModal'
import {
  EditableAssigneeTag,
  RequestTypeTag,
  RequestedByTag,
  RequestedOnTag,
  WorkspaceTag
} from 'modules/requests/components/RequestMetaTags/RequestMetaTags'
import { TagWrapper, TagsWrapper } from 'modules/resultsV2/Results.styles'
import {
  isExternalImportRequestDetail,
  isImportRequestAwaitingManagerDecision
} from 'services/import-requests/importRequestUtils'
import type { ImportRequestVerificationDetail } from 'services/import-requests/types'

interface ImportRequestDetailsTagsProps {
  importRequest: ImportRequestVerificationDetail
}

export const ImportRequestDetailsTags = ({ importRequest }: ImportRequestDetailsTagsProps): JSX.Element => {
  const [isAssignToModalOpen, toggleAssignToModal] = useToggleState(false)

  return (
    <TagsWrapper>
      <TagWrapper>
        <ImportRequestStatusBadge status={importRequest.status} />
      </TagWrapper>
      {/* One icon for the fact "request type", whatever the type turns out to be. */}
      <RequestTypeTag
        icon={<icons.ListSmall />}
        label={isExternalImportRequestDetail(importRequest) ? 'External' : 'Upload'}
      />
      {!!importRequest.requestingUser?.email && <RequestedByTag email={importRequest.requestingUser.email} />}
      <RequestedOnTag at={importRequest.createdAt} />
      {!!importRequest.workspaceName && <WorkspaceTag name={importRequest.workspaceName} />}
      <EditableAssigneeTag
        email={importRequest.assignedTo?.email}
        // External imports await a decision at Pending, uploads at PendingVerification; the same
        // rule the table's assign action uses.
        isEditable={isImportRequestAwaitingManagerDecision(importRequest)}
        onEdit={toggleAssignToModal}
      />

      <ImportRequestAssignToModal
        requestId={importRequest._id}
        open={isAssignToModalOpen}
        onClose={toggleAssignToModal}
        assignedTo={importRequest.assignedTo?._id}
      />
    </TagsWrapper>
  )
}
